import Aib from 'style/imgs/aneta-pack-items/aiblue/aib.svg';
import Aib1 from 'style/imgs/aneta-pack-items/aiblue/aib1.svg';
import Aib2 from 'style/imgs/aneta-pack-items/aiblue/aib2.svg';
import Aib3 from 'style/imgs/aneta-pack-items/aiblue/aib3.svg';
import Aib4 from 'style/imgs/aneta-pack-items/aiblue/aib4.svg';
import Ail from 'style/imgs/aneta-pack-items/aililac/ail.svg';
import Ail1 from 'style/imgs/aneta-pack-items/aililac/ail1.svg';
import Ail2 from 'style/imgs/aneta-pack-items/aililac/ail2.svg';
import Ail3 from 'style/imgs/aneta-pack-items/aililac/ail3.svg';
import Ail4 from 'style/imgs/aneta-pack-items/aililac/ail4.svg';
import Aip from 'style/imgs/aneta-pack-items/aipatina/aip.svg';
import Aip1 from 'style/imgs/aneta-pack-items/aipatina/aip1.svg';
import Aip2 from 'style/imgs/aneta-pack-items/aipatina/aip2.svg';
import Aip3 from 'style/imgs/aneta-pack-items/aipatina/aip3.svg';
import Aip4 from 'style/imgs/aneta-pack-items/aipatina/aip4.svg';
import Aipi from 'style/imgs/aneta-pack-items/aipink/aipi.svg';
import Aipi1 from 'style/imgs/aneta-pack-items/aipink/aipi1.svg';
import Aipi2 from 'style/imgs/aneta-pack-items/aipink/aipi2.svg';
import Aipi3 from 'style/imgs/aneta-pack-items/aipink/aipi3.svg';
import Aipi4 from 'style/imgs/aneta-pack-items/aipink/aipi4.svg';
import Aibv from 'style/imgs/aneta-pack-items/aiblueviolet/aibv.svg';
import Aibv1 from 'style/imgs/aneta-pack-items/aiblueviolet/aibv1.svg';
import Aibv2 from 'style/imgs/aneta-pack-items/aiblueviolet/aibv2.svg';
import Aibv3 from 'style/imgs/aneta-pack-items/aiblueviolet/aibv3.svg';
import Aibv4 from 'style/imgs/aneta-pack-items/aiblueviolet/aibv4.svg';
import Aich from 'style/imgs/aneta-pack-items/aicherry/aich.svg';
import Aich1 from 'style/imgs/aneta-pack-items/aicherry/aich1.svg';
import Aich2 from 'style/imgs/aneta-pack-items/aicherry/aich2.svg';
import Aich3 from 'style/imgs/aneta-pack-items/aicherry/aich3.svg';
import Aich4 from 'style/imgs/aneta-pack-items/aicherry/aich4.svg';
import Aio from 'style/imgs/aneta-pack-items/aiorange/aior.svg';
import Aio1 from 'style/imgs/aneta-pack-items/aiorange/aior1.svg';
import Aio2 from 'style/imgs/aneta-pack-items/aiorange/aio2.svg';
import Aio3 from 'style/imgs/aneta-pack-items/aiorange/aior3.svg';
import Aio4 from 'style/imgs/aneta-pack-items/aiorange/aior4.svg';
import Aibr from 'style/imgs/aneta-pack-items/aibrown/aibr.svg';
import Aibr1 from 'style/imgs/aneta-pack-items/aibrown/aibr1.svg';
import Aibr2 from 'style/imgs/aneta-pack-items/aibrown/aibr2.svg';
import Aibr3 from 'style/imgs/aneta-pack-items/aibrown/aibr3.svg';
import Aibr4 from 'style/imgs/aneta-pack-items/aibrown/aibr4.svg';
import Aig from 'style/imgs/aneta-pack-items/aigrass/aig.svg';
import Aig1 from 'style/imgs/aneta-pack-items/aigrass/aig1.svg';
import Aig2 from 'style/imgs/aneta-pack-items/aigrass/aig2.svg';
import Aig3 from 'style/imgs/aneta-pack-items/aigrass/aig3.svg';
import Aig4 from 'style/imgs/aneta-pack-items/aigrass/aig4.svg';

const anetaPackBags = [
  { id: 1, img: Aib, chipColor: '#6BD5F6' },
  { id: 2, img: Aib1, chipColor: '#6BD5F6' },
  { id: 3, img: Aib2, chipColor: '#6BD5F6' },
  { id: 4, img: Aib3, chipColor: '#6BD5F6' },
  { id: 5, img: Aib4, chipColor: '#6BD5F6' },
  { id: 6, img: Ail, chipColor: '#8D85E7' },
  { id: 7, img: Ail1, chipColor: '#8D85E7' },
  { id: 8, img: Ail2, chipColor: '#8D85E7' },
  { id: 9, img: Ail3, chipColor: '#8D85E7' },
  { id: 10, img: Ail4, chipColor: '#8D85E7' },
  { id: 11, img: Aip, chipColor: '#10C9BE' },
  { id: 12, img: Aip1, chipColor: '#10C9BE' },
  { id: 13, img: Aip2, chipColor: '#10C9BE' },
  { id: 14, img: Aip3, chipColor: '#10C9BE' },
  { id: 15, img: Aip4, chipColor: '#10C9BE' },
  { id: 16, img: Aipi, chipColor: '#F683DD' },
  { id: 17, img: Aipi1, chipColor: '#F683DD' },
  { id: 18, img: Aipi2, chipColor: '#F683DD' },
  { id: 19, img: Aipi3, chipColor: '#F683DD' },
  { id: 20, img: Aipi4, chipColor: '#F683DD' },
  { id: 21, img: Aibv, chipColor: '#BF66E9' },
  { id: 22, img: Aibv1, chipColor: '#BF66E9' },
  { id: 23, img: Aibv2, chipColor: '#BF66E9' },
  { id: 24, img: Aibv3, chipColor: '#BF66E9' },
  { id: 25, img: Aibv4, chipColor: '#BF66E9' },
  { id: 26, img: Aich, chipColor: '#FC7CB2' },
  { id: 27, img: Aich1, chipColor: '#FC7CB2' },
  { id: 28, img: Aich2, chipColor: '#FC7CB2' },
  { id: 29, img: Aich3, chipColor: '#FC7CB2' },
  { id: 30, img: Aich4, chipColor: '#FC7CB2' },
  { id: 31, img: Aio, chipColor: '#FFC148' },
  { id: 32, img: Aio1, chipColor: '#FFC148' },
  { id: 33, img: Aio2, chipColor: '#FFC148' },
  { id: 34, img: Aio3, chipColor: '#FFC148' },
  { id: 35, img: Aio4, chipColor: '#FFC148' },
  { id: 36, img: Aibr, chipColor: '#F3B50D' },
  { id: 37, img: Aibr1, chipColor: '#F3B50D' },
  { id: 38, img: Aibr2, chipColor: '#F3B50D' },
  { id: 39, img: Aibr3, chipColor: '#F3B50D' },
  { id: 40, img: Aibr4, chipColor: '#F3B50D' },
  { id: 41, img: Aig, chipColor: '#00BB3A' },
  { id: 42, img: Aig1, chipColor: '#00BB3A' },
  { id: 43, img: Aig2, chipColor: '#00BB3A' },
  { id: 44, img: Aig3, chipColor: '#00BB3A' },
  { id: 45, img: Aig4, chipColor: '#00BB3A' },
];
export default anetaPackBags;
